import PropTypes from 'prop-types';
import React from 'react';
import Actions from './Actions';
import Balance from './Balance';
import styles from './prepaidCard.module.scss';

const CardInformation = ({
  cardTitle,
  availableBalance,
  spentAmount,
  sensitiveCardData,
  fetchSensitiveCardData,
  fetchSensitiveCardDataError,
  isFetchingSensitiveCardData,
  reportMisuse,
  reportMisuseError,
  isReportingMisuse,
}) => {
  return (
    <div className={styles.cardInformationContainer}>
      <div className={styles.cardInformationInnerContainer}>
        <div className={styles.balancesContainer}>
          <Balance title="Amount available" balance={availableBalance} />
          <Balance title="Amount used" balance={spentAmount} />
        </div>
        <Actions
          cardTitle={cardTitle}
          fetchSensitiveCardData={fetchSensitiveCardData}
          sensitiveCardData={sensitiveCardData}
          isFetchingSensitiveCardData={isFetchingSensitiveCardData}
          fetchSensitiveCardDataError={fetchSensitiveCardDataError}
          reportMisuse={reportMisuse}
          isReportingMisuse={isReportingMisuse}
          reportMisuseError={reportMisuseError}
        />
      </div>
    </div>
  );
};

CardInformation.propTypes = {
  cardTitle: PropTypes.string.isRequired,
  availableBalance: PropTypes.string.isRequired,
  spentAmount: PropTypes.string.isRequired,
  sensitiveCardData: PropTypes.object,
  isFetchingSensitiveCardData: PropTypes.bool.isRequired,
  fetchSensitiveCardDataError: PropTypes.object,
  fetchSensitiveCardData: PropTypes.func.isRequired,
  reportMisuse: PropTypes.func.isRequired,
  isReportingMisuse: PropTypes.bool.isRequired,
  reportMisuseError: PropTypes.object,
};

export default CardInformation;
